import React, { useState, useEffect } from 'react';
import api from '../api';

export default function PushSettings() {
  const [status, setStatus] = useState('unbekannt');
  const [loading, setLoading] = useState(false);
  const [supported, setSupported] = useState(false);
  const [vapidKey, setVapidKey] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      setSupported(true);
      checkStatus();
      // VAPID Key vorab laden
      api.get('/push/vapid-public-key').then(res => {
        setVapidKey(res.data.publicKey);
      }).catch(err => console.error('VAPID Key Fehler:', err));
    }
  }, []);

  const checkStatus = async () => {
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      setStatus(sub ? 'aktiv' : 'inaktiv');
    } catch { setStatus('fehler'); }
  };

  const handleActivate = async () => {
    if (!vapidKey) {
      alert('VAPID Key nicht geladen. Bitte Seite neu laden.');
      return;
    }
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
      await api.post('/push/subscribe', { subscription: sub });
      setStatus('aktiv');
      alert('✅ Push-Benachrichtigungen aktiviert!');
    } catch (err) {
      alert('Fehler: ' + err.message);
    } finally { setLoading(false); }
  };

  const handleDeactivate = async () => {
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) await sub.unsubscribe();
      await api.delete('/push/subscribe');
      setStatus('inaktiv');
    } catch (err) {
      alert('Fehler: ' + err.message);
    } finally { setLoading(false); }
  };

  const handleTest = async () => {
    try {
      await api.post('/push/test');
      alert('Test-Benachrichtigung gesendet!');
    } catch { alert('Fehler beim Senden'); }
  };

  if (!supported) return (
    <div style={{ background: '#1e293b', borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
      <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
        🔔 Push-Benachrichtigungen
      </h3>
      <p style={{ color: '#64748b', fontSize: 13 }}>
        Nicht unterstützt. Bitte Safari auf iPhone oder Chrome auf Desktop verwenden.
      </p>
    </div>
  );

  return (
    <div style={{ background: '#1e293b', borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
      <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
        🔔 Push-Benachrichtigungen
      </h3>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div>
          <div style={{ color: '#f1f5f9', fontSize: 14 }}>
            Status:{' '}
            <span style={{ color: status === 'aktiv' ? '#34d399' : '#f87171', fontWeight: 600 }}>
              {status === 'aktiv' ? '✅ Aktiv' : '❌ Inaktiv'}
            </span>
          </div>
          <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
            Erinnerungen direkt aufs iPhone
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {status === 'aktiv' ? (
            <>
              <button onClick={handleTest} disabled={loading} style={btnStyle('#f59e0b')}>
                🧪 Test
              </button>
              <button onClick={handleDeactivate} disabled={loading} style={btnStyle('#ef4444')}>
                {loading ? '⏳' : 'Deaktivieren'}
              </button>
            </>
          ) : (
            <button onClick={handleActivate} disabled={loading || !vapidKey} style={btnStyle('#10b981')}>
              {loading ? '⏳ Aktivieren...' : !vapidKey ? '⏳ Laden...' : '🔔 Aktivieren'}
            </button>
          )}
        </div>
      </div>
      <div style={{ background: '#0f172a', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: '#64748b' }}>
        💡 Nach Aktivierung erhältst du automatisch Benachrichtigungen wenn eine Kündigungsfrist in{' '}
        <strong style={{ color: '#94a3b8' }}>30 Tagen</strong> abläuft – auch wenn die App geschlossen ist.
      </div>
    </div>
  );
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(c => c.charCodeAt(0)));
}

function btnStyle(color) {
  return {
    background: `${color}22`, color, border: `1px solid ${color}44`,
    padding: '7px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600,
  };
}
